import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Navbar.css';

function Navbar() {
  const location = useLocation();

  const isActive = (path) => {
    return location.pathname === path ? 'active' : '';
  };

  return (
    <nav className="navbar">
      <div className="nav-container">
        <Link to="/" className="nav-logo">
          📦 Stock Manager
        </Link>
        <div className="nav-links">
          <Link to="/" className={isActive('/')}>Home</Link>
          <Link to="/add-stock" className={isActive('/add-stock')}>Add Stock</Link>
          <Link to="/view-stock" className={isActive('/view-stock')}>View Stock</Link>
          <Link to="/subtract-stock" className={isActive('/subtract-stock')}>Subtract Stock</Link>
          <Link to="/history" className={isActive('/history')}>History</Link>
        </div>
      </div>
    </nav>
  );
}

export default Navbar;